import { create } from 'zustand'

interface SnippetEditorState {
  /** Snippet whose library sheet is open, or null when it is closed. */
  editingSnippetId: string | null
  /**
   * The duty whose own wording the sheet is editing, or null for the shared
   * snippet. Set when the sheet was opened from a block inside that duty's
   * script — the same sheet, editing a different row.
   */
  editingDutyId: string | null
  openSnippetEditor: (snippetId: string, dutyId?: string) => void
  closeSnippetEditor: () => void
}

/**
 * Which snippet the library sheet is editing.
 *
 * A store rather than component state because the trigger is the Edit button on
 * a snippet block, which lives inside a Milkdown NodeView — and the sheet embeds
 * `MilkdownMarkdownEditor` for its content field, so the editor cannot render
 * the sheet itself without an import cycle. `SnippetEditorSheetHost` is mounted
 * once in the app shell and listens here.
 */
export const useSnippetEditorStore = create<SnippetEditorState>()((set) => ({
  editingSnippetId: null,
  editingDutyId: null,
  openSnippetEditor: (snippetId, dutyId) =>
    set({ editingSnippetId: snippetId, editingDutyId: dutyId ?? null }),
  closeSnippetEditor: () =>
    set({ editingSnippetId: null, editingDutyId: null }),
}))
